import BaseApiService from "./BaseApiService";

const _login = (payload) => {
  return BaseApiService.post(`/api/v1/auth/login`, null, payload);
};

const _forgotPassword = (payload) => {
  return BaseApiService.post(`/api/v1/forgotPassword/sendOtp`, null, payload);
};

const _verifyOtp = (payload) => {
  return BaseApiService.post(`/api/v1/forgotPassword/verifyOtp`, null, payload);
};

const _resetPassword = (payload) => {
  return BaseApiService.post(`/api/v1/resetPassword`, null, payload);
};
const _logout = (payload) => {
  return BaseApiService.post(`/api/v1/logout`,null,payload);
};

const _requestOTP=(payload)=>{
  return BaseApiService.post(`/api/v1/auth/send-otp`,null,payload);
}

const _OTPLogin=(payload)=>{
  return BaseApiService.post(`/api/v1/auth/login-with-otp`,null,payload);
}

export const AuthApiService = {
  login: _login,
  logout: _logout,
  forgotPassword:_forgotPassword,
  verifyOtp: _verifyOtp,
  resetPassword:_resetPassword,
  requestOTP:_requestOTP,
  OTPLogin:_OTPLogin
};
